'use client';

import { type ComponentProps, forwardRef } from 'react';
import Link from 'next/link';
import { mergeProps } from '@frameio/vapor';
import { usePrefetch } from '../hooks/usePrefetch';

/**
 * Next Link prewired up to use our Link prefetch strategy
 */
export const LinkWithPrefetch = forwardRef<
  HTMLAnchorElement,
  ComponentProps<typeof Link> & { href: string }
>((props, forwardedRef) => {
  const prefetchProps = usePrefetch(props.href, {
    isNextLink: true,
    placement: 'SINGLE',
  });

  return <Link {...mergeProps(props, prefetchProps)} ref={forwardedRef} />;
});
